// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import HideableController from "./hideable_controller"
application.register("hideable", HideableController)

import InspectionFormController from "./inspection_form_controller"
application.register("inspection-form", InspectionFormController)

import QrcodeController from "./qrcode_controller"
application.register("qrcode", QrcodeController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlimController from "./slim_controller"
application.register("slim", SlimController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import DocumentPreviewController from "./document_preview_controller"
application.register("document-preview", DocumentPreviewController)
